import React from 'react';
import { Row, Col, Card } from 'reactstrap';
// import { HashLink as Link } from 'react-router-hash-link';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';

const BlogCard = (props) => {
    const blogs = props.data;
    return (
        <Row className="">
            {blogs.map((blog, index) => {
                return (
                    <Col key={index} lg="6" md="6">
                        <Card className='my-card'>
                            <Link className='m-auto text-center' to={`/blog-detail/${blog?.paragraph?.toLowerCase().replace(/\s+/g, '-')}`} state={{ title: blog?.paragraph }} aria-label={blog?.heading} >
                                <LazyLoadImage
                                    className="card-img-top"
                                    alt={'blog-img'}
                                    effect="blur"
                                    // height={image.height}
                                    src={blog?.userImg} // use normal <img> attributes as props
                                // width={image.width}
                                />
                                {/* <img className="card-img-top" src={blog.userImg} alt="wrappixel kit" /> */}
                            </Link>
                            <div className='p-4 paragraph'>
                                {blog?.createdDate && <p className="">
                                    {blog?.createdDate}
                                </p>}
                                <Link to={`/blog-detail/${blog?.paragraph?.toLowerCase().replace(/\s+/g, '-')}`} state={{ title: blog?.paragraph }} aria-label={blog?.heading} className="link">
                                    <div className=''>
                                        {blog?.heading && <h4 className='font-medium m-0'>{blog?.heading}</h4>}
                                    </div>
                                    {blog?.subTitle && <h4 className='font-small m-0'>{blog?.subTitle}</h4>}
                                </Link>
                                {/* <h5 className="font-medium text-truncate" title={blog?.paragraph}>
                                    <Link to={`/blog-detail?id=${blog?.id}`} className="link">
                                        {blog?.paragraph}
                                    </Link>
                                </h5> */}
                                {blog?.name && <span className="linking text-themecolor pt-2">{blog?.name}</span>}
                            </div>
                        </Card>
                    </Col>
                )
            })}
        </Row>
    );
}
export default BlogCard;
